<template>
  <div class="w-full lg:p-3">
    <skeleton
      class="mb-3 mt-6 h-[32px] !w-[254px] md:mb-2 md:mt-8 md:h-[40px]"
    />
    <skeleton
      class="h-[216px] !w-full max-sm:mb-3 md:mb-8 md:h-[120px] lg:h-[112px]"
    />
    <div
      class="grid grid-cols-2 gap-x-2 gap-y-4 md:grid-cols-3 md:gap-x-6 lg:grid-cols-5"
    >
      <div v-for="i in [1, 2, 3, 4, 5, 6]" :key="i" class="p-2">
        <skeleton class="h-[168] w-full md:h-[210px] lg:h-[269px]" />
        <skeleton class="my-5 h-[40px]" />
      </div>
    </div>
  </div>
</template>

<script setup></script>
